import { LMS_INIT_SUCCESS, FILTER_REQUEST_SUCCESS, SORT_SUCCESS } from '../constants';

const allTripTypes = [
  {
    key: 'SPECIFIED',
    metadataKey: 'nrOfSpecified',
    gtm: {
      value: 'CharterSpecified',
    },
  },
  {
    key: 'FLIGHTONLY',
    metadataKey: 'nrOfFlightOnly',
    gtm: {
      value: 'CharterFlightOnly',
    },
  },
];

const allTripLengths = [
  {
    key: 'durationTo',
    metadataKey: 'all',
    value: -1,
    default: true,
    gtm: {
      event: 'Search',
      travelDuration: 'NoneChosen',
    },
  },
  {
    key: 'durationTo',
    metadataKey: 'oneweek',
    value: 10,
    minValue: 7,
    maxValue: 10,
    gtm: {
      travelDuration: 8,
    },
  },
  {
    key: 'durationTo',
    metadataKey: 'twoweeks',
    value: 18,
    minValue: 11,
    maxValue: 18,
    gtm: {
      travelDuration: 15,
    },
  },
  {
    key: 'durationTo',
    metadataKey: 'threeweeks',
    value: 25,
    minValue: 19,
    maxValue: 25,
    gtm: {
      travelDuration: 22,
    },
  },
  {
    key: 'durationTo',
    metadataKey: 'miniweek',
    value: 6,
    minValue: 0,
    maxValue: 6,
    gtm: {
      travelDuration: 4,
    },
  },
  {
    key: 'durationFrom',
    metadataKey: 'longvacation',
    value: 26,
    minValue: 26,
    gtm: {
      travelDuration: 29,
    },
  },
];

const initialState = {
  price: {
    max: 0,
    min: 0,
  },
  destinations: [],
  totalCount: 0,
  dates: [],
  departures: [],
  tripTypes: [...allTripTypes],
  tripLengths: [...allTripLengths],
};

const updateState = (state, payload) => {
  const durations = payload?.durations && {};

  return {
    ...state,
    price: {
      min: payload?.price?.min || state.price.min,
      max: payload?.price?.max || state.price.min,
    },
    destinations: payload?.countries || [],
    tripTypes: allTripTypes.map((current) => {
      if (payload && payload[current.metadataKey]) {
        return {
          ...current,
          count: payload[current.metadataKey],
        };
      }

      return current;
    }),
    totalCount: payload?.totalCount || 0,
    tripLengths: allTripLengths.filter((tl) => {
      return durations[tl.metadataKey] !== false;
    }),
    dates: payload?.dates || [],
    departures: payload?.departures || [],
  };
};

const filtersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LMS_INIT_SUCCESS:
    case FILTER_REQUEST_SUCCESS:
    case SORT_SUCCESS:
      return updateState(state, payload);

    default:
      return state;
  }
};

export default filtersReducer;
